import type { Bordereau, Mouvement } from '@mairistem/comptabilite';
import type { TemplateRequestGet } from '@mairistem/finances-utils';
import { request } from '@mairistem/tools';
import DuplicatePayload from '../../../interfaces/pieces/DuplicatePayload';

const baseUrl = '/api/finances/comptabilite/piecescomptables/mouvements';

const getMouvements = (params: URLSearchParams) => request.get<unknown, TemplateRequestGet<Mouvement>>(`${baseUrl}?${params.toString()}`);

export const dupliquerMouvement = (
  mouvement: Partial<Mouvement>,
  shouldReprendreReferences?: boolean,
  bordereauIsModel?: boolean,
  dateEcheance?: string,
  dateDepartDelaiGlobalPaiement?: string,
  datePrelevement?: string,
  dateRealisationPrestationDebut?: string,
  dateRealisationPrestationFin?: string,
  bordereau?: Partial<Bordereau>,
) => {
  const parameters: DuplicatePayload = {
    idBordereau: mouvement.identifiantBordereau,
    shouldReprendreReferences,
    willBeModel: bordereauIsModel,
    dateEcheance,
    dateDepartDelaiGlobalPaiement,
    datePrelevement,
    dateRealisationPrestationDebut,
    dateRealisationPrestationFin,
    bordereau,
  };

  const url = `${baseUrl}/dupliquer/${mouvement.identifiant}`;
  return request.post<DuplicatePayload, Mouvement>(url, parameters);
};

export const supprimerMouvement = (identifiant: number) => request.delete<unknown, unknown>(`${baseUrl}/${identifiant}`);

export default getMouvements;
